import { useState } from "react";

export const useNumbersSelection = ({
    getRowKey
}) => {
    const [selectedData, setSelectedData] = useState({ all: false, list: [] });
    const [selectedItems, setSelectedItems] = useState(new Map());

    const keepSelectedItems = (data, checked) => {
        const updatedItems = new Map(selectedItems);

        const rowKey = getRowKey();

        for (const item of data) {
            if (checked) {
                updatedItems.set(item[rowKey], item);
            } else {
                updatedItems.delete(item[rowKey]);
            }
        }

        setSelectedItems(updatedItems);
    };

    return { selectedData, selectedItems, setSelectedData, setSelectedItems, keepSelectedItems };
};